// extracted by mini-css-extract-plugin
export default {"modal":"nba-z","modalContent":"oba-z","footer":"pba-z","cancelBtn":"qba-z","disabled":"rba-z","formWrapper":"sba-z","fade":"tba-z","fade-in":"uba-z","iframe":"vba-z"};